import { useState } from 'react'
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from '@headlessui/react'
import Badge from '../ui/Badge'
import { inputClasses } from '../ui/Input'
import { classNames } from '../../lib/classNames'

export default function TagInput({ tags, allTags, onChange }) {
    const [query, setQuery] = useState('')

    const normalized = tags.map((t) => t.toLowerCase())
    const suggestions = allTags.filter(
        (t) => t.toLowerCase().includes(query.trim().toLowerCase()) && !normalized.includes(t.toLowerCase())
    )
    const exactMatch = suggestions.some((s) => s.toLowerCase() === query.trim().toLowerCase())

    const addTag = (raw) => {
        const value = raw.trim()
        if (!value || normalized.includes(value.toLowerCase())) {
            setQuery('')
            return
        }
        onChange([...tags, value])
        setQuery('')
    }

    const removeTag = (tag) => onChange(tags.filter((t) => t !== tag))

    return (
        <div>
            {tags.length > 0 && (
                <div className="flex flex-wrap items-center gap-1.5 mb-2">
                    {tags.map((tag) => (
                        <Badge key={tag} tone="accent" className="gap-1.5">
                            {tag}
                            <button
                                type="button"
                                onClick={() => removeTag(tag)}
                                aria-label={`Remove tag ${tag}`}
                                className="hover:text-red-600"
                            >
                                ×
                            </button>
                        </Badge>
                    ))}
                </div>
            )}
            <Combobox value={null} onChange={(value) => value && addTag(value)}>
                <div className="relative">
                    <ComboboxInput
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && query.trim() && !exactMatch) {
                                e.preventDefault()
                                addTag(query)
                            }
                        }}
                        placeholder="Add a tag..."
                        className={inputClasses()}
                        aria-label="Add tag"
                    />
                    {suggestions.length > 0 && (
                        <ComboboxOptions className="absolute z-10 mt-1 w-full max-h-48 overflow-auto border-2 border-black dark:border-white bg-white dark:bg-zinc-950">
                            {suggestions.map((s) => (
                                <ComboboxOption
                                    key={s}
                                    value={s}
                                    className={({ focus }) =>
                                        classNames('px-3 py-1.5 text-sm cursor-pointer', focus ? 'bg-accent text-black' : 'text-black dark:text-white')
                                    }
                                >
                                    {s}
                                </ComboboxOption>
                            ))}
                        </ComboboxOptions>
                    )}
                </div>
            </Combobox>
        </div>
    )
}
